<div class="flex items-center gap-1">
  <div class="text-sm line-through">
    <app-currency [amount]="originalPrice()" />
  </div>

  <div>
    <app-currency [amount]="currentPrice()" />
  </div>
</div>
